import React from "react";

import { useApp } from "../../contexts/AppContext";

export const Loader = () => (
  <div className="app__loader">
    <div className="loader">Loading...</div>
  </div>
);

export const LoaderSmall = () => {
  const { whitelabel } = useApp();

  return (
    <div id="preloader-active">
      <div className="preloader">
        <div className="preloader-inner">
          <img
            src={whitelabel?.loading_gif_url || "https://i.sstatic.net/kOnzy.gif"}
            alt="Gif Loading"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export const LoaderCheckout = () => (
  <div id="preloader-active">
    <div className="preloader">
      <div className="preloader-inner">
        <div className="preloader-circle" />
        <h3 className="mt-4 fw-bold">Aguarde...</h3>
        <p>Estamos processando seu pedido.</p>
      </div>
    </div>
  </div>
);
